export const datePointReverse = (date = '') => {
  return date.split('.').reverse().join('-');
};
